export enum CustomizerOption {
  CUSTOMIZE_FOR_ME = "Help Me Write",
  GET_BRAND_INFO = "Brand Info",
}
